(() => {
  const instances = new Map();
  function init(root) {
    if (instances.has(root)) return;
    const controller = new AbortController(), signal = controller.signal;
    const slides = [...root.querySelectorAll('[data-slide]')], dots = [...root.querySelectorAll('[data-carousel-index]')];
    const reduced = matchMedia('(prefers-reduced-motion:reduce)'), mobile = matchMedia('(max-width:700px)');
    const respectReducedMotion = root.dataset.respectReducedMotion === 'true';
    const motionAllowed = () => !respectReducedMotion || !reduced.matches;
    const pendingVideos = new WeakSet();
    let index=0,timer,paused=false,drag;
    const listen=(el,type,fn)=>el?.addEventListener(type,fn,{signal});
    function schedule() {
      clearTimeout(timer);
      if(slides.length>1 && root.dataset.autoplay==='true' && !paused && !document.hidden && motionAllowed())
        timer=setTimeout(()=>go(index+1),Math.max(2,Number(root.dataset.interval)||6)*1000);
    }
    function videoCanPlay(video) {
      return !signal.aborted && video.isConnected && video.closest('[data-slide]') === slides[index]
        && video.dataset.play === 'true' && motionAllowed() && !document.hidden;
    }
    function setMuted(video) {
      video.muted = video.dataset.muted !== 'false' || video.dataset.autoplayMuted === 'true';
      video.defaultMuted = video.muted;
    }
    async function attemptVideo(video) {
      if (!videoCanPlay(video) || pendingVideos.has(video) || !video.paused) return;
      setMuted(video);
      pendingVideos.add(video);
      try {
        await video.play();
        delete video.dataset.autoplayBlocked;
      } catch (error) {
        // A browser may allow muted autoplay while refusing the merchant's sound setting.
        if (error.name === 'NotAllowedError' && !video.muted && videoCanPlay(video)) {
          video.dataset.autoplayMuted = 'true';
          setMuted(video);
          try {
            await video.play();
            delete video.dataset.autoplayBlocked;
          } catch (fallbackError) {
            // Keep the poster when the browser also blocks muted playback; do not loop retries.
            video.dataset.autoplayBlocked = fallbackError.name;
          }
        } else if (error.name !== 'AbortError') {
          // AbortError is expected when changing slides or responsive video sources.
          video.dataset.autoplayBlocked = error.name;
        }
      } finally {
        pendingVideos.delete(video);
        if (!videoCanPlay(video)) video.pause();
      }
    }
    function media() {
      slides.forEach((slide,i)=>slide.querySelectorAll('video').forEach(video=>{
        setMuted(video);
        video.playsInline = true;
        video.setAttribute('playsinline','');
        video.setAttribute('webkit-playsinline','');
        video.poster=mobile.matches?video.dataset.posterMobile:video.dataset.posterDesktop;
        const sources=[...video.querySelectorAll('source[data-src]')];
        const chosen=sources.find(s=>s.dataset.device===(mobile.matches?'mobile':'desktop'));
        if(!chosen){video.pause();video.removeAttribute('src');video.hidden=true;return;}video.hidden=false;
        const active = videoCanPlay(video);
        video.autoplay = active;
        if(chosen && video.getAttribute('src')!==chosen.dataset.src){video.src=chosen.dataset.src;video.load();}
        if(active) attemptVideo(video); else video.pause();
      }));
    }
    function go(value){
      if(!slides.length)return;
      index=(value+slides.length)%slides.length;
      slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===index);slide.inert=i!==index;slide.setAttribute('aria-hidden',String(i!==index));});
      dots.forEach((dot,i)=>{dot.classList.toggle('is-active',i===index);dot.setAttribute('aria-current',i===index?'true':'false');});
      media();schedule();
    }
    root.querySelectorAll('[data-carousel-prev],[data-carousel-next]').forEach(button=>{button.hidden=slides.length<2;listen(button,'click',()=>go(index+(button.hasAttribute('data-carousel-prev')?-1:1)));});
    dots.forEach((dot,i)=>listen(dot,'click',()=>go(i)));
    root.querySelectorAll('video').forEach(video=>{
      listen(video,'loadedmetadata',()=>attemptVideo(video));
      listen(video,'canplay',()=>attemptVideo(video));
    });
    listen(root,'pointerdown',e=>{if(root.dataset.swipe==='true'&&!e.target.closest('a,button,input')&&e.isPrimary)drag={x:e.clientX,y:e.clientY};});
    listen(root,'pointerup',e=>{if(!drag)return;const dx=e.clientX-drag.x,dy=e.clientY-drag.y;drag=null;if(Math.abs(dx)>44&&Math.abs(dx)>Math.abs(dy))go(index+(dx<0?1:-1));});
    listen(root,'pointercancel',()=>drag=null);
    listen(root,'keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();go(index+(e.key==='ArrowRight'?1:-1));}});
    listen(root,'shopify:block:select',e=>{const i=slides.findIndex(slide=>slide===e.target||slide.contains(e.target));if(i>=0){paused=true;go(i);}});
    listen(root,'shopify:block:deselect',()=>{paused=false;media();schedule();});
    // Retry on a real user gesture or a restored tab; never add a storefront play button.
    listen(document,'pointerup',()=>slides[index]?.querySelectorAll('video').forEach(video=>{
      if (video.dataset.autoplayBlocked === 'NotAllowedError' && !video.ended) attemptVideo(video);
    }));
    listen(window,'pageshow',()=>{media();schedule();});
    listen(document,'visibilitychange',()=>{media();schedule();});listen(mobile,'change',media);listen(reduced,'change',()=>{media();schedule();});
    instances.set(root,()=>{controller.abort();clearTimeout(timer);slides.forEach(slide=>slide.querySelector('video')?.pause());});go(0);
  }
  const boot=scope=>scope.querySelectorAll('[data-v31-carousel]').forEach(init);
  boot(document);
  document.addEventListener('shopify:section:load',e=>boot(e.target));
  document.addEventListener('shopify:section:unload',e=>instances.forEach((dispose,root)=>{if(e.target.contains(root)){dispose();instances.delete(root);}}));
})();
